import http from '../httpClient';
import { getTokenString } from '../tokenService';

function buildBaseParams() {
  const tcs = getTokenString();
  if (!tcs) return null;

  const token = tcs.split('&')[0];
  const companyId = new URLSearchParams(tcs.split('&').slice(1).join('&')).get('companyId');

  if (!token || token.toLowerCase?.() === 'null' || !companyId) return null;

  return { section: 'adminPanel', token, companyId };
}

export const getStart = () => {
  const baseParams = buildBaseParams();
  if (!baseParams) return Promise.reject(new Error('auth-missing'));

  return http.get('/', { params: { action: 'getStart', ...baseParams } });
};